// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";

var S1 = {
  name: "V3TooltipContext.S1"
};

var Trigger = ContextMaker$LiteracyplanetClientFlags.Make(S1);

var S2 = {
  name: "V3TooltipContext.S2"
};

var Consumer = ContextMaker$LiteracyplanetClientFlags.Make(S2);

function V3TooltipContext$Provider(props) {
  var match = React.useState(function () {
        
      });
  var setOver = match[1];
  var isOver = match[0];
  var onEnter = function (id) {
    setOver(function (param) {
          return id;
        });
  };
  var onLeave = function (id) {
    setOver(function (param) {
          
        });
  };
  return React.createElement(Trigger.Provider.make, {
              value: {
                onEnter: onEnter,
                onLeave: onLeave,
                isOver: isOver
              },
              children: React.createElement(Consumer.Provider.make, {
                    value: {
                      isOver: isOver
                    },
                    children: props.children
                  })
            });
}

var Provider = {
  make: V3TooltipContext$Provider
};

var useTrigger = Trigger.use;

var useConsumer = Consumer.use;

export {
  S1 ,
  Trigger ,
  useTrigger ,
  S2 ,
  Consumer ,
  useConsumer ,
  Provider ,
}
/* Trigger Not a pure module */
